module.exports = __webpack_public_path__ + "c6583ecabf79d03926b33f5a4134a481.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon-arrow-down.svg
// module id = D4Hc
// module chunks = 5